/**
 * Flag de cutover para estado de leitura por membro (conversation_member_state).
 * Default: OFF — mantém update direto em conversations.unread_count.
 */

function isTruthyFlag(value: unknown): boolean {
  if (value === true || value === 1) return true;
  if (typeof value !== "string") return false;
  const normalized = value.trim().toLowerCase().replace(/^["']|["']$/g, "");
  return normalized === "true" || normalized === "1" || normalized === "yes";
}

export function isMemberReadStateEnabled(): boolean {
  return isTruthyFlag(import.meta.env.VITE_MEMBER_READ_STATE);
}
